import Form from '../Form/Form';

import { initForm, destroyForm } from '../../actions/form';
import { getValidConfig, customModFormJson } from '../../lib/customModifyForm'

import './App.scss';
import { FormJson } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Dispatch } from 'redux';

import { path } from 'ramda';

type CleanFormProps = {
  display: boolean;
  formInstanceId: string;
  innerFormInstanceId?: string;
  formJson?: FormJson;
  componentSuccessCallback?: (...args: any[]) => void;
};

interface FormProps extends CleanFormProps, ReduxComponentInterface {
  mode?: string;
}

class App extends window.React.PureComponent<FormProps> {
  componentDidMount() {
    const { actions, formInstanceId, formJson, innerFormInstanceId } = this.props;
    if (formJson) {
      const deps = getValidConfig(formJson.fields);
      const formJsonInit: FormJson = deps ? customModFormJson(formJson, deps) : formJson;
      actions.initForm(formJsonInit, formInstanceId, innerFormInstanceId);
    }
  }

  componentWillUnmount() {
    const { actions, formInstanceId, innerFormInstanceId } = this.props;
    actions.destroyForm(formInstanceId, innerFormInstanceId);
  }

  render() {
    const { formInstanceId, display, mode, componentSuccessCallback, innerFormInstanceId } = this.props;

    if (!display || !mode) return null;

    return (
      <div className="react-root form-instance-wrapper" data-instance={formInstanceId}>
        <Form {...{ formInstanceId, componentSuccessCallback, innerFormInstanceId }} readOnly={mode === 'view'} />
      </div>
    );
  }
}

const mapStateToProps = (state: any, props: CleanFormProps) => {
  let pathToMode: string[] = ['mode'];
  if (props.innerFormInstanceId) {
    pathToMode = [props.formInstanceId, 'form', props.innerFormInstanceId, ...pathToMode];
  } else {
    pathToMode = [props.formInstanceId, 'form', ...pathToMode];
  }

  return {
    mode: path(pathToMode, state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ initForm, destroyForm }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(App);
